import React from "react";
import {
	Appbar,
	BottomNavigator,
	LoginAlert,
	Overlay,
	GameAlert,
} from "@components";
import styled from "styled-components";
import HomeRoutes from "./HomeRoutes";
import { useLocation } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { NoInternet } from "@pages";

const Container = styled.div`
	min-height: 100vh;
	position: relative;
`;

const Home = () => {
	const { pathname } = useLocation();

	if (!navigator.onLine) {
		return <NoInternet />;
	}

	return (
		<>
			<Container>
				{pathname !== `/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.NOTIFICATION}` && (
					<Appbar />
				)}
				<HomeRoutes />
				<BottomNavigator />
			</Container>
			<LoginAlert />
			<Overlay />
			<GameAlert />
		</>
	);
};

export default Home;
